module.exports = __webpack_public_path__ + "media/images/front/pc/treatment-introduction-article/img_doctor-3cbaf8cec9b7c5699c324bfcfa36116a.jpg";